export default "__VITE_ASSET__3THaM6sR__"